import React, { useEffect, useState } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Pagination, Autoplay } from "swiper/modules";
import slider1 from "../../../assets/images/1slider.png";
import slider2 from "../../../assets/images/2slider.png";
import slider3 from "../../../assets/images/3slider.png";
import service1 from "../../../assets/images/blog01.webp";
import service2 from "../../../assets/images/blog02.webp";
import service3 from "../../../assets/images/blog03.webp";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import { Container } from "react-bootstrap";
import { FaArrowRight } from "react-icons/fa";
import Testimonials from "../Home/Testimonials";
import VendorCategories from "../Home/Services";
import Ecosystem from "../Home/Ecosystem";
import Features from "../Home/Features";
import Registration from "../Home/Registration";
import UniqueUsp from "../Home/Unique";
import B2bmodal from "../Home/B2bModal";
import ThreeLayer from "../Home/ThreeLayer";
import Revenue from "../Home/Revenue";
import Workflow from "../Home/Workflow";
import FrechiseCta from "../Home/FrechiseCta";
import { IoLogoGooglePlaystore } from "react-icons/io5";
import { getWebSlider } from "../../server/api";

function Home() {
  const [sliders, setSliders] = useState([]);

  const fetchSliders = async () => {
      try {
        const res = await getWebSlider();
        if (res.status == true) {
          const filtered = res.data;
          console.warn("ssssssss", filtered);
          setSliders(filtered);
        }
        else {
          alert("Hello");
        }
  
      } catch (error) {
        console.error("Slider API Error:", error);
      }
    };
  
    useEffect(() => {
      fetchSliders();
    }, []);

  const worksData = [
    {
      title: "Hyper-local Assignments",
      desc: "A smart location-based system that connects requests with the most relevant local service partners.",
      img: service1,
    },
    {
      title: "Weekly Payouts",
      desc: "Earnings are settled every week, ensuring timely and transparent payments without delays.",
      img: service2,
    },
    {
      title: "Incentives & Rewards",
      desc: "Get rewarded for good work with performance-based bonuses and benefits.",
      img: service3,
    },
  ];

  return (
    <div className="hero-section">
      <div className="slider">
        <Swiper
          modules={[Navigation, Pagination, Autoplay]}
          navigation
          pagination={{ clickable: true }}
          autoplay={{ delay: 800000 }}
          loop={true}
          spaceBetween={30}
          slidesPerView={1}
        >
          {sliders.map((img, index) => (
            <SwiperSlide key={index}>
              <img
                src={`${process.env.REACT_APP_URL}${img.image}`}
                alt={`Slide ${index + 1}`}
                style={{ width: "100%" }}
              />

              <section className="hero-section_popup">
                <div className="hero-content-glass p-4 p-md-5 rounded-4">
                  <h1 className="display-4 fw-bold mb-4">{img.title}</h1>

                  <p className="lead mb-4">{img.description}</p>

                  <div className="d-flex flex-wrap gap-3 mb-4">
                    <button className="primary_btn btn btn-primary btn-lg rounded-pill px-5 py-3">
                      <IoLogoGooglePlaystore /> Download App
                    </button>
                  </div>
                </div>
              </section>
            </SwiperSlide>
          ))}
        </Swiper>

        <Ecosystem />
        <VendorCategories />
        <Features />
      </div>

      <section className="works-section">
        <Container>
          <div className="works-container">
            {/* Header */}
            <div className="works-header">
              <span className="works-subtitle">About Our Works</span>
              <h2 className="works-title">Key Benefits</h2>
              <p className="works-description">
                We are running conditioning firm since five decades. As time
                passes we are getting more advance as technology is changing
                everyday.
              </p>
            </div>

            {/* Cards */}
            <div className="works-grid">
              {worksData.map((item, index) => (
                <div className="work-card" key={index}>
                  <div className="work-image">
                    <img src={item.img} alt={item.title} />
                  </div>

                  <div className="work-content">
                    <h5>{item.title}</h5>
                    <p>{item.desc}</p>
                    <a href="#" className="work-link">
                      Learn More <FaArrowRight />
                    </a>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </Container>
      </section>

      <Registration />
      <UniqueUsp />
      <B2bmodal />
      <ThreeLayer />
      <Revenue />
      <Workflow />
      <Testimonials />
      <FrechiseCta />
    </div>
  );
}

export default Home;
